export default __webpack_public_path__ + "static/media/Mercenary's Helm of the Second Caste.943c969e.jpg";